import React from 'react';

interface StepEstablishmentNameProps {
    formData: {
        establishmentName: string;
    };
    updateFormData: (data: { establishmentName: string }) => void;
    onNext: () => void;
    onBack: () => void;
    error: string | null;
}

const StepEstablishmentName: React.FC<StepEstablishmentNameProps> = ({
    formData,
    updateFormData,
    onNext,
    onBack,
    error
}) => {
    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        onNext();
    };

    return (
        <form onSubmit={handleSubmit} className="space-y-6">
            <div className="text-center mb-8">
                <p className="text-sm text-primary font-medium mb-2">Informações adicionais</p>
                <h2 className="text-2xl font-bold text-gray-900">Nome do seu estabelecimento</h2>
                <p className="text-gray-500 text-sm mt-2">Como seus clientes conhecem seu negócio?</p>
            </div>

            {error && (
                <div className="p-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">
                    {error}
                </div>
            )}

            <div>
                <label htmlFor="establishmentName" className="block text-sm font-medium text-gray-700 mb-1">
                    Nome do Salão / Barbearia
                </label>
                <input
                    id="establishmentName"
                    type="text"
                    value={formData.establishmentName}
                    onChange={(e) => updateFormData({ establishmentName: e.target.value })}
                    className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all text-lg"
                    placeholder="Ex: Salão da Maria, Barbearia do João"
                    autoFocus
                />
            </div>

            <button
                type="submit"
                disabled={!formData.establishmentName.trim()}
                className="w-full py-3 px-4 bg-primary hover:bg-primary-dark text-white font-semibold rounded-xl transition-all shadow-sm disabled:opacity-50 disabled:cursor-not-allowed"
            >
                Continuar
            </button>
        </form>
    );
};

export default StepEstablishmentName;
